export default {
  vehicleParts: [],
  vehiclePart: undefined,
};
